export default "__VITE_ASSET__DKDf2$YM__"